wp.customize('osf_typography_general_body_font', function (value) {
    value.bind(function (to) {
        $('head').each((index, element) => {
            OSFPreviewCallback.reloadGoogleFont(element, to, '')
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_general_heading_font', function (value) {
    value.bind(function (to) {
        $('head').each((index, element) => {
            OSFPreviewCallback.reloadGoogleFont(element, to, '')
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_general_tertiary_font', function (value) {
    value.bind(function (to) {
        $('head').each((index, element) => {
            OSFPreviewCallback.reloadGoogleFont(element, to, '')
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_general_quaternary_font', function (value) {
    value.bind(function (to) {
        $('head').each((index, element) => {
            OSFPreviewCallback.reloadGoogleFont(element, to, '')
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_general_body_font_size', function (value) {
    value.bind(function (to) {
        $('html').each((index, element) => {
            element.style.fontSize = to + 'px';
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_general_body_letter_spacing', function (value) {
    value.bind(function (to) {
        $('html').each((index, element) => {
            element.style.letterSpacing = to + 'px';
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_general_heading_font_style', function (value) {
    value.bind(function (to) {
        $('.entry-title,.heading,.single-orealestate_property .comment-reply-title, .osf-feature-box.style-2 .title, .osf-feature-box.style-1.left .title').each((index, element) => {
            OSFPreviewCallback.fontStyle(element, to, '')
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_general_heading_letter_spacing', function (value) {
    value.bind(function (to) {
        $('.entry-title,.heading,.single-orealestate_property .comment-reply-title, .osf-feature-box.style-2 .title, .osf-feature-box.style-1.left .title').each((index, element) => {
            element.style.letterSpacing = to + 'px';
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_button_font_family', function (value) {
    value.bind(function (to) {
        $('head').each((index, element) => {
            OSFPreviewCallback.reloadGoogleFont(element, to, '')
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_button_font_style', function (value) {
    value.bind(function (to) {
        $('.vc_btn3, button, .button-primary').each((index, element) => {
            OSFPreviewCallback.fontStyle(element, to, '')
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_typography_buttom_letter_spacing', function (value) {
    value.bind(function (to) {
        $('button, input[type="submit"], input[type="reset"], input[type="button"], .button, .btn').each((index, element) => {
            element.style.letterSpacing = to + 'px';
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_colors_general_body', function (value) {
    value.bind(function (to) {
        $('body').css('color', to);
    });
});
wp.customize('osf_colors_page_title_bg_position', function (value) {
    value.bind(function (to) {
        $('.page-title-bar').each((index, element) => {
            element.style.backgroundPosition = to + '';
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_page_404_bg_position', function (value) {
    value.bind(function (to) {
        $('.error404 .site-content-contain').each((index, element) => {
            element.style.backgroundPosition = to + '';
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_page_404_bg', function (value) {
    value.bind(function (to) {
        $('.error404 .site-content-contain').each((index, element) => {
            element.style.backgroundColor = to + '';
        });
        OSFPreviewSectionHover.getInstance().setPosition();
    });
});
wp.customize('osf_footer_copyright', function (value) {
    value.bind(function (to) {
        $('.site-info > div').text(to);
    });
});
